import { Badge, Subtitle, Text, Title } from '@tremor/react';
import { SubscriptionDetailsProps } from './SubscriptionDetailsCard';

export function Details({
  createdAt,
  subscriptionTier,
  userEmail,
  userName,
}: Omit<SubscriptionDetailsProps, 'isSubscription'>) {
  const label = 'mt-3';
  const text = 'font-bold text-[rgb(55,65,81)] text-lg mt-0.5 leading-5';
  return (
    <>
      <Title className="font-bold mb-3 text-2xl leading-7">Subscription Details</Title>
      <Subtitle className={label}>Name</Subtitle>
      <Text className={text}>{userName}</Text>
      <Subtitle className={label}>Email</Subtitle>
      <Text className={text}>{userEmail}</Text>
      <Subtitle className={label}>Created</Subtitle>
      <Text className={text}>{createdAt.toDate().toDateString()}</Text>
      <Subtitle className={label}>Subscription Tier</Subtitle>
      <Badge className="text-primary-default mt-0.5 bg-primary-100">
        {subscriptionTier}
      </Badge>
    </>
  );
}
